import React, { useEffect, useState } from 'react';

// 同源部署：前端与 API 同域（Cloudflare Pages Functions），留空即为相对路径
const API_BASE = process.env.REACT_APP_API_URL || '';

function App() {
  const [backendStatus, setBackendStatus] = useState<'checking' | 'online' | 'offline'>('checking');
  const [backendInfo, setBackendInfo] = useState<any>(null);
  const [keyword, setKeyword] = useState('');
  const [results, setResults] = useState<any[]>([]);
  const [searching, setSearching] = useState(false);
  const [searched, setSearched] = useState(false);

  useEffect(() => {
    // 检查后端健康状态（云模式：显示实时连接状态）
    fetch(`${API_BASE}/health`, { method: 'GET' })
      .then(res => res.json())
      .then(data => {
        setBackendStatus(data.status === 'ok' ? 'online' : 'offline');
        setBackendInfo(data);
      })
      .catch(() => {
        setBackendStatus('offline');
      });
  }, []);

  const doSearch = () => {
    const kw = keyword.trim();
    if (!kw) return;
    setSearching(true);
    setSearched(true);
    fetch(`${API_BASE}/api/search?keyword=${encodeURIComponent(kw)}`)
      .then(res => res.json())
      .then(data => setResults(data.results || []))
      .catch(() => setResults([]))
      .finally(() => setSearching(false));
  };

  const statusEmoji = backendStatus === 'online' ? '✅' : backendStatus === 'offline' ? '❌' : '⏳';
  const statusText = backendStatus === 'online' ? '运行正常' : backendStatus === 'offline' ? '离线或启动中' : '检查中...';

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif', maxWidth: '900px', margin: '0 auto' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '10px' }}>
        <h1 style={{ color: '#1890ff', margin: 0 }}>🌿 中药信息系统 · 后台管理</h1>
        <a href="/" style={{ color: '#1890ff', textDecoration: 'none', fontSize: '0.95rem', padding: '6px 14px', border: '1px solid #91d5ff', borderRadius: '6px', backgroundColor: '#e6f7ff' }}>
          ← 返回用户首页
        </a>
      </div>
      <p style={{ color: '#8c8c8c' }}>管理控制台 · 系统状态监控与 API 调试</p>

      <div style={{ marginTop: '20px' }}>
        <h3>功能特色：</h3>
        <ul>
          <li>🔍 智能中药搜索</li>
          <li>🧪 配伍分析</li>
          <li>📸 图片识别</li>
          <li>📊 数据统计</li>
        </ul>
      </div>

      <div style={{ marginTop: '20px', padding: '15px', backgroundColor: '#f0f2f5', borderRadius: '8px', border: '1px solid #d9d9d9' }}>
        <h3 style={{ marginTop: 0 }}>🌐 云端部署状态</h3>
        <div style={{ marginBottom: '8px' }}>
          <strong>管理后台：</strong> ✅ 运行中
          <span style={{ marginLeft: '10px', color: '#8c8c8c', fontSize: '0.9em' }}>
            (Cloudflare Pages · /admin)
          </span>
        </div>
        <div style={{ marginBottom: '8px' }}>
          <strong>后端 API：</strong> {statusEmoji} {statusText}
          <span style={{ marginLeft: '10px', color: '#8c8c8c', fontSize: '0.9em' }}>
            (Cloudflare Pages Functions · 同源)
          </span>
        </div>
        {backendInfo && backendInfo.database && (
          <div style={{ marginBottom: '8px' }}>
            <strong>数据源：</strong> {backendInfo.database === 'embedded' ? '✅ 内嵌数据' : backendInfo.database}
          </div>
        )}
        <div>
          <strong>版本：</strong> v1.0.0
        </div>
      </div>

      <div style={{ marginTop: '30px', padding: '15px', backgroundColor: '#fff', borderRadius: '8px', border: '1px solid #d9d9d9' }}>
        <h3 style={{ marginTop: 0 }}>🔍 中药搜索（在线体验）</h3>
        <div style={{ display: 'flex', gap: '8px' }}>
          <input
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter') doSearch(); }}
            placeholder="输入中药名、功效或主治，如：人参、清热、补气"
            style={{ flex: 1, padding: '8px 12px', fontSize: '14px', border: '1px solid #d9d9d9', borderRadius: '4px' }}
          />
          <button
            onClick={doSearch}
            style={{ padding: '8px 20px', fontSize: '14px', color: '#fff', backgroundColor: '#1890ff', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
          >
            {searching ? '搜索中...' : '搜索'}
          </button>
        </div>
        <div style={{ marginTop: '15px' }}>
          {searched && !searching && results.length === 0 && (
            <p style={{ color: '#8c8c8c' }}>没有找到匹配的中药。</p>
          )}
          {results.map((r) => (
            <div key={r.id} style={{ padding: '12px', marginBottom: '8px', backgroundColor: '#fafafa', borderRadius: '6px', border: '1px solid #f0f0f0' }}>
              <div style={{ fontWeight: 'bold', fontSize: '16px', color: '#262626' }}>
                {r.name}
                {r.alias && <span style={{ fontWeight: 'normal', fontSize: '13px', color: '#8c8c8c', marginLeft: '10px' }}>别名：{r.alias}</span>}
              </div>
              {r.taste && <div style={{ fontSize: '13px', color: '#595959', marginTop: '4px' }}>性味：{r.taste}</div>}
              {r.functions && <div style={{ fontSize: '13px', color: '#595959', marginTop: '4px' }}>功效：{r.functions}</div>}
            </div>
          ))}
        </div>
      </div>

      <div style={{ marginTop: '30px', padding: '15px', backgroundColor: '#e6f7ff', borderRadius: '8px', border: '1px solid #91d5ff' }}>
        <h3 style={{ marginTop: 0 }}>📡 API 端点</h3>
        <p style={{ margin: '5px 0' }}>
          <code style={{ backgroundColor: '#fff', padding: '2px 6px', borderRadius: '3px' }}>
            GET /api/medicines
          </code> — 获取中药列表
        </p>
        <p style={{ margin: '5px 0' }}>
          <code style={{ backgroundColor: '#fff', padding: '2px 6px', borderRadius: '3px' }}>
            GET /api/search?keyword=xxx
          </code> — 搜索中药
        </p>
        <p style={{ margin: '5px 0' }}>
          <code style={{ backgroundColor: '#fff', padding: '2px 6px', borderRadius: '3px' }}>
            POST /api/medicines/analyze
          </code> — 配伍分析
        </p>
        <p style={{ margin: '5px 0' }}>
          <code style={{ backgroundColor: '#fff', padding: '2px 6px', borderRadius: '3px' }}>
            GET /api/medicines/:id
          </code> — 中药详情
        </p>
      </div>

      <div style={{ marginTop: '30px', fontSize: '0.9em', color: '#595959' }}>
        <p><strong>部署架构（全栈运行于 Cloudflare）：</strong></p>
        <ul style={{ lineHeight: '1.8' }}>
          <li>前端：Cloudflare Pages（全球 CDN 加速）</li>
          <li>后端 API：Cloudflare Pages Functions（_worker.js，同域）</li>
          <li>数据：内嵌于 Worker（只读）。如需持久化搜索日志，可为 API Token 添加 D1 权限后迁移至 D1</li>
        </ul>
        <p style={{ marginTop: '15px' }}>
          <strong>代码仓库：</strong>{' '}
          <a href="https://github.com/youjunyu/tcm-info-system" target="_blank" rel="noopener noreferrer" style={{ color: '#1890ff' }}>
            github.com/youjunyu/tcm-info-system
          </a>{' '}
          <span style={{ color: '#8c8c8c' }}>(private)</span>
        </p>
      </div>
    </div>
  );
}

export default App;
